import * as React from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { MachineTranslationSettings } from "gen/clients/llts";

interface Props {
  mtSettings: MachineTranslationSettings;
  onNext: (action: AiToolboxAction) => void;
}

export enum AiToolboxAction {
  IMPROVE_TRANSLATION = "IMPROVE_TRANSLATION",
  ADD_WATERMARK = "ADD_WATERMARK"
}

const SelectActionStep: React.FC<Props> = ({ mtSettings, onNext }) => {
  const { t } = useTranslation();

  const actions = [
    ...(!mtSettings?.aiToolboxSettings?.hidePostEditAction
      ? [
          {
            type: AiToolboxAction.IMPROVE_TRANSLATION,
            title: t("machineTranslation.aiToolbox.actions.improveTranslation.title"),
            description: t("machineTranslation.aiToolbox.actions.improveTranslation.description")
          }
        ]
      : []),
    ...(!mtSettings?.aiToolboxSettings?.hideWatermarkAction
      ? [
          {
            type: AiToolboxAction.ADD_WATERMARK,
            title: t("machineTranslation.aiToolbox.actions.addWatermark.title"),
            description: t("machineTranslation.aiToolbox.actions.addWatermark.description")
          }
        ]
      : [])
  ];

  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 500, color: "primary.main" }}>
        {t("machineTranslation.aiToolbox.actions.prompt.title")}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t("machineTranslation.aiToolbox.actions.prompt.description")}
      </Typography>
      {actions.map(action => (
        <Button
          key={action.type}
          onClick={() => onNext(action.type)}
          variant="outlined"
          sx={{
            p: 3,
            textAlign: "left",
            display: "block",
            minHeight: "100px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)"
            }
          }}
        >
          <Typography variant="subtitle1" component="div" sx={{ fontWeight: "bold", mb: 1 }}>
            {action.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4, textTransform: "none" }}>
            {action.description}
          </Typography>
        </Button>
      ))}
    </Stack>
  );
};

export { SelectActionStep };
